import React from "react";
import { useLocalization } from "../../../context/LocalizationContext";
import StoreBadge from "../StoreBadge";
import appleIcon from "../../../assets/icons/newDesign/apple.svg";
import googlePlayIcon from "../../../assets/icons/newDesign/googlePlay.svg";

const AppStoreBadges: React.FC = () => {
  const { t } = useLocalization();
  return (
    <div className="instructions-store-badges">
      <StoreBadge
        icon={appleIcon}
        tagline={t("instructions.downloadOnThe")}
        storeName={t("instructions.appStore")}
      />
      <StoreBadge
        icon={googlePlayIcon}
        tagline={t("instructions.getItOn")}
        storeName={t("instructions.googlePlay")}
      />
    </div>
  );
};

export default AppStoreBadges;
